/**
 * Erro PLAN_LIMIT_EXCEEDED da API: o plano travou a entrada de cliente novo
 * (passou do limite de clientes/mês no mês passado e já bateu no deste).
 * Vem com os dados do plano para a mensagem de upgrade.
 */
export interface PlanLimitExceededPayload {
  code: 'PLAN_LIMIT_EXCEEDED';
  message: string;
  planName: string;
  capacity: string | null;
  limit: number;
  used: number;
}

/**
 * Erro PLAN_SEATS_EXCEEDED: adicionar, reativar ou ligar "atende" num
 * profissional passaria dos profissionais contratados pela organização.
 */
export interface PlanSeatsExceededPayload {
  code: 'PLAN_SEATS_EXCEEDED';
  message: string;
  /** Profissionais que atendem, já contando o novo. */
  requested: number;
  /** Contratados hoje; `null` enquanto a organização estiver num plano solo. */
  limit: number | null;
}

export type PlanLimitPayload = PlanLimitExceededPayload | PlanSeatsExceededPayload;

const PLAN_LIMIT_CODES = new Set(['PLAN_LIMIT_EXCEEDED', 'PLAN_SEATS_EXCEEDED']);

export function parsePlanLimitError(err: unknown): PlanLimitPayload | null {
  const data = (err as { response?: { data?: any } })?.response?.data;
  if (!data) return null;
  // NestJS devolve o objeto da exceção direto; alguns proxies aninham em `message`.
  const payload = typeof data.message === 'object' ? data.message : data;
  return PLAN_LIMIT_CODES.has(payload?.code) ? (payload as PlanLimitPayload) : null;
}
